import { Grid, Typography, MenuItem } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';


import {
  setUnidadesNegocioSelecionadas,
} from '../../../../../features/tarifario/tarifarioSlice';

import QCXSelectManyUnidadeNegocioFinalFormTable from '../../../../../components/unidade-negocio/QCXSelectManyUnidadeNegocioFinalFormTable';


export default function TarifaUnidadesCompartilhadasDataForm({
  model,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  ...restFormProps
}){

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const unidadesNegocio = useMemo(() => (
    model?.unidadesDeNegocio || []
  ), [model]);

  const handleSetSelectedUnidadesNegocio = (data) => {
    console.log('Selected Unidades de Negocio: ', data);
    dispatch(setUnidadesNegocioSelecionadas(data));
  };

  return (
    <>
        <QCXSelectManyUnidadeNegocioFinalFormTable
          key="ficha-unidade-negocio-servico"
          list={unidadesNegocio}
          isConsult={isConsult}
          handleChange={handleSetSelectedUnidadesNegocio}
          controlComponentProps={controlComponentProps}
          authInfo={authInfo}
          requiredRoles={requiredRoles}
          onSubmit={handleSubmit}
          {...restFormProps}
        />
    </>
  )
}
